<div class="login-container">
  <app-breadcrumb [title]="'Login' | transloco" icon="login" loggedOutAction="register"></app-breadcrumb>
  <app-login [urlAfterLogin]="urlAfterLogin$ | async" [presetFunctionAfterLogin]="presetFunctionAfterLogin$ | async"
    [inForgotPassword]="inForgotPassword"></app-login>
</div>
